import { Children, type FC, type ReactNode } from "react";
import MyAccountRegistered from "~/features/myAccount/profile/components/MyAccountRegistered/MyAccountRegistered";
import { userIsLoggedIn, userIsRegistered } from "~/domains/user/utils/roles";
import MyAccountB2B from "~/features/myAccount/profile/components/MyAccountB2B/MyAccountB2B";
import { type MyAccountDataJSP } from "~/features/myAccount/profile/myAccountTypes";
import { transformMyAccountData } from "~/features/myAccount/profile/myAccountDataTransformers";
import { styled } from "~/common/mui";

export function createMyAccountPage(data: MyAccountDataJSP) {
  return <MyAccountContainer {...data} />;
}

export const MyAccountContainer = (dataDto: MyAccountDataJSP) => {
  const loggedIn = userIsLoggedIn();
  const registeredUser = userIsRegistered();

  const data = transformMyAccountData(dataDto);

  return <>{loggedIn && <>{registeredUser ? <MyAccountRegistered data={data} /> : <MyAccountB2B data={data} />}</>}</>;
};

interface FormSectionProps extends Omit<JSX.IntrinsicElements["div"], "title"> {
  title?: ReactNode;
  className?: string;
  children?: ReactNode;
}

export const FormSection: FC<FormSectionProps> = ({ children, title, className, ...rest }) => {
  return (
    <FormSectionRoot className={className} {...rest}>
      {title && <FormSectionTitle>{title}</FormSectionTitle>}
      {Children.map(children, (child) => child && <FormSectionField>{child}</FormSectionField>)}
    </FormSectionRoot>
  );
};

const FormSectionRoot = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(3.75),
}));

const FormSectionTitle = styled("h3")(({ theme }) => ({
  ...theme.typography.titleLarge,
  marginTop: 0,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up("tablet")]: {
    ...theme.typography.headlineSmall,
    marginBottom: theme.spacing(3),
  },
}));

const FormSectionField = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(2),
  width: "100%",
  [theme.breakpoints.up("desktop-s")]: {
    width: "unset",
  },
}));
